import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideDressfit } from '@pixacare/dressfit-angular';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { FormComponentInputs } from '../../models/form-component-inputs';
import { FormOutputs } from '../../models/form-outputs';
import { FormComponent } from '../form/form.component';

@Component({
  selector: 'pxc-dialog-form',
  templateUrl: './dialog-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormComponent],
  providers: [provideDressfit()],
})
export class DialogFormComponent {
  private readonly context = injectContext<TuiDialogContext<FormOutputs, FormComponentInputs>>();

  readonly form = this.context.data.form;
  readonly formAnswer = this.context.data.formAnswer;
  readonly formInputs = this.context.data.formInputs;
  readonly readOnly = this.context.data.readOnly ?? false;

  complete(outputs: FormOutputs | null): void {
    this.context.completeWith(outputs);
  }
}
